import React, { createContext, useCallback, useContext, useState } from "react";

/* ------------------------------- Toasts ------------------------------- */

const ToastContext = createContext(() => {});

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const notify = useCallback((message, type = "info", duration = 3200) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  }, []);

  return (
    <ToastContext.Provider value={notify}>
      {children}
      <div className="lf-toast-wrap">
        {toasts.map((t) => (
          <div key={t.id} className={`lf-toast ${t.type}`}>
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

/* --------------------------- Confirm dialog --------------------------- */

export function ConfirmDialog({ open, title, message, confirmLabel = "Confirm", onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div className="lf-confirm-overlay" onClick={onCancel}>
      <div className="lf-confirm-box" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="lf-confirm-actions">
          <button className="lf-btn lf-btn-ghost" onClick={onCancel}>
            Cancel
          </button>
          <button className="lf-btn lf-btn-danger" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
